import { CentaxApiList } from "./centax-api.constant";

export const CachableRoutePatterns = {
	[CentaxApiList.LEFT_MENU]: true
};
